import { FC, forwardRef, useMemo } from 'react';

import { TooltipProps, Tooltip as MantineTooltip } from '@mantine/core';

import { useMergeClassNames } from '../../utils';

import { TooltipOverrideClassNames } from './Tooltip.styles';

const Tooltip: FC<TooltipProps> = forwardRef<HTMLDivElement, TooltipProps>(
  ({ children, classNames, ...props }, ref) => {
    const classes = useMemo(() => {
      return TooltipOverrideClassNames();
    }, []);

    const mergedClassNames = useMergeClassNames({
      classNames: [classes, classNames]
    });

    return (
      <MantineTooltip ref={ref} {...props} classNames={mergedClassNames}>
        {children}
      </MantineTooltip>
    );
  }
);

export { Tooltip };
export type { TooltipProps };
